import { render } from "./MyClubs.vue?vue&type=template&id=6aeb8345"
import script from "./MyClubs.vue?vue&type=script&lang=js"
export * from "./MyClubs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__